
import envi from './environment'
import settings from './settings.json'
import { ACTIONS as DATA_ACTIONS } from "../redux/reducers/DataReducer"

const prevFetched = {};

export const client = (dispatch)=>{
    const environment = envi();
    let _ = settings.settings;

    return {
        getData : ()=>{return " hello "}
    }
}



export default client;

